/**
 * Section Component
 * Wrapper for page sections with consistent spacing and backgrounds
 */

import React from 'react';
import './Section.css';

/**
 * @param {Object} props
 * @param {'default'|'light'|'dark'|'gradient'} [props.background='default'] - Background style
 * @param {'small'|'default'|'large'|'hero'} [props.spacing='default'] - Vertical padding size
 * @param {string} [props.id] - Section ID for anchoring
 * @param {React.ReactNode} props.children - Section content
 */
function Section({
    background = 'default',
    spacing = 'default',
    id,
    children,
    className = '',
    ...props
}) {
    const classNames = [
        'section',
        background !== 'default' && `section--${background}`,
        spacing !== 'default' && `section--${spacing}`,
        className
    ].filter(Boolean).join(' ');

    return (
        <section id={id} className={classNames} {...props}>
            <div className="section__container">
                {children}
            </div>
        </section>
    );
}

/**
 * Section Header subcomponent for consistent title styling
 */
function SectionHeader({ subtitle, title, description, children }) {
    return (
        <header className="section__header">
            {subtitle && <span className="section__subtitle">{subtitle}</span>}
            {title && <h2 className="section__title">{title}</h2>}
            {description && <p className="section__description">{description}</p>}
            {children}
        </header>
    );
}

Section.Header = SectionHeader;

export default Section;
